import React from 'react'
import PropTypes from 'prop-types'

import invalid from '../../assets/images/invalid.svg'

export const EditMode = ({
  editData,
  onUpdate,
  handleSubmit3,
  register3,
  updateCallMutation,
  closeEdit,
  errors3,
  setOpenActivity,
}) => {
  return (
    <div key={new Date()}>
      <form onSubmit={handleSubmit3(onUpdate)} id="addActivityEdit" data-testid="formAddEdit">
        <div className="trtui-row trtui-g-2">
          <div className={`trtui-col-md-6 trtui-has-validation`}>
            <label className="trtui-form-control-label">Type</label>
            <div className="trtui-input-group trtui-has-validation">
              <input
                type="text"
                placeholder="Label"
                className={`trtui-form-control ${errors3['activityDetailType'] && 'trtui-is-invalid'}`}
                style={{
                  color: '#000000',
                  paddingRight: 'calc(1.5em + 1rem)',
                  backgroundImage: errors3['activityDetailType'] && `url("${invalid}")`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                  backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
                }}
                {...register3('activityDetailType')}
                defaultValue={editData['activityDetailType']}
              />
              {errors3['activityDetailType'] && (
                <div className="trtui-invalid-feedback">
                  {errors3['activityDetailType'].message}
                </div>
              )}
            </div>
          </div>
          <div className={`trtui-col-md-6 trtui-has-validation`}>
            <label className="trtui-form-control-label">Label</label>
            <div className="trtui-input-group trtui-has-validation">
              <input
                type="text"
                placeholder="Label"
                className={`trtui-form-control ${errors3['activityDetailLabel'] && 'trtui-is-invalid'}`}
                {...register3('activityDetailLabel')}
                defaultValue={editData['activityDetailLabel']}
              />
              {errors3['activityDetailLabel'] && (
                <div className="trtui-invalid-feedback">
                  {errors3['activityDetailLabel'].message}
                </div>
              )}
            </div>
          </div>
          <div className={`trtui-col-md-6 trtui-has-validation`}>
            <label className="trtui-form-label">Description</label>
            <textarea
              type="text"
              placeholder="Description"
              {...register3('activityDetailDescription')}
              className={`trtui-form-control ${errors3['activityDetailDescription'] && 'trtui-is-invalid'}`}
            >
              {editData['activityDetailDescription']}
            </textarea>
            {errors3['activityDetailDescription'] && (
              <div className="trtui-invalid-feedback">
                {errors3['activityDetailDescription'].message}
              </div>
            )}
          </div>
          <div className={`trtui-col-md-6 trtui-has-validation`}>
            <label className="trtui-form-label">Notes</label>
            <textarea
              type="text"
              placeholder="Notes"
              {...register3('activityDetailNotes')}
              className={`trtui-form-control ${errors3['activityDetailNotes'] && 'trtui-is-invalid'}`}
              style={{
                color: '#000000',
                paddingRight: 'calc(1.5em + 1rem)',
                backgroundImage: errors3['activityDetailNotes'] && `url("${invalid}")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
              }}
            >
              {editData['activityDetailNotes']}
            </textarea>
            {errors3['activityDetailNotes'] && (
              <div className="trtui-invalid-feedback">{errors3['activityDetailNotes'].message}</div>
            )}
          </div>
          <div className="trtui-col-12">
            <button
              className={`trtui-btn trtui-btn-success trtui-btn-sm`}
              type="submit"
              disabled={updateCallMutation.isLoading}
            >
              {updateCallMutation.isLoading ? (
                <span className="trtui-d-flex trtui-align-items-center">
                  <span className="trtui-flex-grow-1 trtui-me-2">Updating...</span>
                  <span className="trtui-spinner-border trtui-flex-shrink-0" role="status">
                    <span className="trtui-visually-hidden">Updating...</span>
                  </span>
                </span>
              ) : (
                'Update'
              )}
            </button>{' '}
            <button
              className={`trtui-btn trtui-btn-light trtui-btn-sm`}
              type="button"
              disabled={updateCallMutation.isLoading}
              onClick={() => {
                closeEdit()
                setOpenActivity()
              }}
            >
              Close
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

EditMode.propTypes = {
  editData: PropTypes.object,
  handleSubmit3: PropTypes.func,
  updateCallMutation: PropTypes.object,
  closeEdit: PropTypes.func,
  errors3: PropTypes.object,
  onUpdate: PropTypes.func,
  register3: PropTypes.func,
  enableEdit: PropTypes.bool,
  setOpenActivity: PropTypes.func,
}
